export const body = {
    paddingRight: "30px",
    paddingTop: "20px",
    height: "100%",
    overflow: "scroll"
};

export const columnRight = {
    textAlign: "right"
};

export const buttons = {
    textAlign: "center"
};

export const redText = {
    color: "red"
};

//MOBILE
export const mobile_body = {
    padding: "5px"
};

export const mobile_totalsContainer = {
    // border: "1px solid black",
    display: "flex",
    flexDirection: "row"
};

export const mobile_totalsHeadings = {
    // border: "1px solid black",
    flex: "1",
    textAlign: "right"
};

export const mobile_totalsPrices = {
    // border: "1px solid black",
    paddingLeft: "5px"
};

export const mobile_buttonContainer = {
    display: "flex",
    flexDirection: "column"
};
